import { useQuery } from "react-query";
import { isQueryReady } from "src/api/axiosClient/utils";
import { fetchOrganizationGrid } from "./useGetAllOrganization";

export const suppliersKey = "getSuppliers" as const;

type Options = {
    page?: number;
    itemsPerPage?: number;
    search?: string;
    enabled?: boolean;
};

export const useGetSuppliers = (options: Options = {}) => {
    const { page = 1, itemsPerPage = 20, search = "", enabled = true } = options;

    const query = useQuery({
        queryKey: [suppliersKey, page, itemsPerPage, search],
        enabled,
        staleTime: 0,
        cacheTime: 0,
        queryFn: () =>
            fetchOrganizationGrid(
                "/api/suppliers",
                { page, itemsPerPage, q: search !== "" ? search : undefined },
                suppliersKey,
            ),
    });

    return {
        ...query.data,
        isReady: isQueryReady(query, enabled),
        ...query,
    };
};
